import { defineComponent } from 'vue';
import type { AxiosError } from 'axios';
import type { ErrorScreenProps } from '@/components/composables/useApiErrors';
import useApiErrors from '@/components/composables/useApiErrors';

// TODO: This has been converted to a composable, but this is still used at the global level.  Need
//  to clean up after Vue 3 migration.

export default defineComponent({
  methods: {
    makeErrorScreenParams(error: AxiosError): ErrorScreenProps {
      return useApiErrors().makeErrorScreenParams(error);
    }
  }
});
